import React, {useState} from 'react';

import css from './PromoCodesComponent.module.css';
import {ButtonCreate} from "../../../ui/ButtonCreate/ButtonCreate";
import {
    PromoCodesCreatePromoCodeModal
} from "../settingSectionModals/PromoCodesCreatePromoCodeModal/PromoCodesCreatePromoCodeModal";
import PromoCodesListComponent from "../PromoCodesListComponent/PromoCodesListComponent";


const PromoCodesComponent = () => {
    const [isOpen, setIsOpen] = useState(false);

    const handleClick = () => {
        setIsOpen(true);
    };


    return (
        <section className={css.wrap}>

            <section className={css.btnBlock}>
                <ButtonCreate onClick={handleClick}/>
            </section>

            <section className={css.listBlock}>
                <PromoCodesListComponent/>
            </section>

            {isOpen && <PromoCodesCreatePromoCodeModal setIsOpen={setIsOpen}/>}
        </section>
    );
};

export {PromoCodesComponent};